import DateTimeHelper from '../../utils/DateTimeHelper';
import GameCode from '../games/GameCode';

class Character {
    id;
    userId;
    playerId;
    gameCode;
    identificationName;
    verificationNumber;
    isVerified;

    // undefinedable
    // nullable
    gameDataRefreshedAt;

    createdAt;
    updatedAt;

    constructor(id, userId, playerId, gameCode, identificationName, verificationNumber, isVerified, gameDataRefreshedAt, createdAt, updatedAt) {
        this.id = id;
        this.userId = userId;
        this.playerId = playerId;
        this.gameCode = gameCode;
        this.identificationName = identificationName;
        this.verificationNumber = verificationNumber;
        this.isVerified = isVerified;
        this.gameDataRefreshedAt = gameDataRefreshedAt;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }

    merge(jsonObj) {
        if (jsonObj.hasOwnProperty('id')) {
            this.id = jsonObj.id;
        }

        if (jsonObj.hasOwnProperty('userId')) {
            this.userId = jsonObj.userId;
        }

        if (jsonObj.hasOwnProperty('playerId')) {
            this.playerId = jsonObj.playerId;
        }

        if (jsonObj.hasOwnProperty('gameCode')) {
            this.gameCode = GameCode.valueOfWireName(jsonObj.gameCode);
        }

        if (jsonObj.hasOwnProperty('identificationName')) {
            this.identificationName = jsonObj.identificationName;
        }

        if (jsonObj.hasOwnProperty('verificationNumber')) {
            this.verificationNumber = jsonObj.verificationNumber;
        }

        if (jsonObj.hasOwnProperty('isVerified')) {
            this.isVerified = jsonObj.isVerified;
        }

        if (jsonObj.hasOwnProperty('gameDataRefreshedAt')) {
            this.gameDataRefreshedAt = DateTimeHelper.convertISO8601StringToDate(jsonObj.gameDataRefreshedAt);
        }

        if (jsonObj.hasOwnProperty('createdAt')) {
            this.createdAt = DateTimeHelper.convertISO8601StringToDate(jsonObj.createdAt);
        }

        if (jsonObj.hasOwnProperty('updatedAt')) {
            this.updatedAt = DateTimeHelper.convertISO8601StringToDate(jsonObj.updatedAt);
        }
    }
}

export default Character;
